<fa-icon
  [icon]="getIcon()"
  [matTooltip]="text"
  [ngClass]="{ 'exclamation-icon': type === 'exclamation' }"
></fa-icon>
